export default "__VITE_ASSET__CmD8JU16__"